module.exports = __webpack_public_path__ + "static/media/village-orera.1c4b11eb.png";